<template>
  <section>
    <h1>Promo Codes</h1>
    <div class="my-3">
      <v-layout row wrap>
        <v-flex xs4 fluid align-center justify-center>
          <v-btn color="primary" @click="showEditModal" v-if="isWriteAvailable">
            Add promo code
          </v-btn>
          <v-btn color="primary" @click="reset">
            Reset
          </v-btn>
          <v-btn
            color="primary"
            slot="activator"
            @click.stop="showPromocodesSettings()"
          >
            <span>Edit settings</span>
          </v-btn>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            append-icon="search"
            label="Search by Name"
            v-model="filterName"
          />
        </v-flex>
        <v-flex xs2 ml-4>
          <v-select
            :items="statusArr"
            v-model="filterStatus"
            label="Status"
          />
        </v-flex>
        <v-flex xs2 ml-4>
          <v-text-field
            append-icon="search"
            label="Search by Use Count"
            v-model="filterUseCount"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 fluid align-center justify-center>
          <v-dialog persistent v-model="isModalOpen" max-width="800px">
            <v-card v-if="isModalOpen">
              <v-card-title>
              </v-card-title>
              <v-card-text>
                <promo-codes-form
                  ref="promoCodesForm"
                  :editableItem="editableItem"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="closeModal">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="savePromoCode">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="promoCodesList"
        class="elevation-1 wrap"
        :pagination.sync="pagination"
        :total-items="totalItemsInTable"
        :loading="loading"
        item-key="id"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">
          <td class="py-4">{{ props.item.name }}</td>
          <td class="py-4">{{ getDate( props.item.creationDate) }}</td>
          <td class="py-4">{{ getAdminByPackage(pathOr('',[ 'item', 'createdBy'], props )) }}</td>
          <td class="py-4">{{ props.item.useCount }}</td>
          <td class="py-4">{{ props.item.countOfUsagesByAttendees }}</td>
          <td class="py-4">{{ props.item.countOfAssignedAttendees  }}</td>
          <td class="py-4">{{ convertDate(props.item.activationDate) }}</td>
          <td class="py-4">{{ convertDate(props.item.expirationDate) }}</td>
          <td class="py-4">{{ getInteger(pathOr('', ['item', 'discountInPercent'], props)) }}</td>
          <td class="py-4">{{ pathOr('', ['item', 'discountInCurrency'], props) }}</td>
          <td class="py-4">{{ props.item.status }}</td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="lime"
                fab flat
                slot="activator"
                @click.stop="showEditModal(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>create</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="pageText" slot-scope="{}">
          Page {{pagination.page}} of {{totalPromoCodesPages}}
        </template>
      </v-data-table>
    </div>

    <v-dialog persistent v-model="isPromocodeDialogShown" max-width="700px">
      <v-card>
        <v-card-title>
          <span>Promo Codes Settings</span>
          <v-spacer/>

        </v-card-title>
        <v-card-text>
          <v-card class="input">
            <content-editor
              label="Explanation text"
              v-model="promocodeSettings.explanation"
              :error="$v.promocodeSettings.explanation"
              @input="$v.promocodeSettings.explanation.$touch()"
              @blur="$v.promocodeSettings.explanation.$touch()"
            />
          </v-card>
          <v-spacer/>
          <v-switch
            :label="displayStatus"
            v-model="promocodeSettings.areEnabled"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" flat @click.stop="savePromoCodeSettings()">Save</v-btn>
          <v-btn color="info" flat @click.stop="hidePromocodesSettings">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import promoCodesForm from './promoCodesForm'
  import debounce from 'lodash.debounce'
  import { timeSettings } from '@/modules/settings/'
  import { equals, clone, pathOr, isEmpty } from 'ramda'
  import { required, url } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'

  export default {
    name: 'promo-codes',
    mixins: [mixins.isWriteAvailable],
    components: {
      promoCodesForm
    },
    data () {
      return {
        headers: [
          { text: 'Name', value: 'name', search: false, sortable: true },
          { text: 'Date created', value: 'creationDate', search: false, sortable: true },
          { text: 'Created by', value: 'createdBy', search: false, sortable: true },
          { text: 'Usage limitation', value: 'useCount', search: false, sortable: true },
          { text: 'Usage Counter', value: 'CountOfUsagesByAttendees', search: false, sortable: true },
          { text: 'Assigned Attendees', value: 'CountOfAssignedAttendees', search: false, sortable: true },
          { text: 'Activation Date', value: 'activationDate', search: false, sortable: false },
          { text: 'Expiration Date', value: 'expirationDate', search: false, sortable: false },
          { text: 'Discount in Percent', value: 'discountInPercent', search: false, sortable: true },
          { text: 'Discount in Currency', value: 'discountInCurrency', search: false, sortable: true },
          { text: 'Status', value: 'status', search: false, sortable: true },
          { text: 'Edit', search: false, sortable: false, align: 'center' }
          // { text: 'Delete', search: false, sortable: false, align: 'center' }
        ],
        loading: true,
        isModalOpen: false,
        editableItem: null,
        isValidationError: false,
        isPromocodeDialogShown: false,
        promocodeSettings: {
          'explanation': '',
          'areEnabled': false
        },
        statusArr: [
          'Live',
          'Stopped'
        ],
        filterName: '',
        filterStatus: '',
        filterUseCount: '',
        pagination: {
          rowsPerPage: 5
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters([
        'promoCodesList',
        'totalPromoCodesPages',
        'totalPromoCodesItems',
        'getUsersList',
        'getSettings'
      ]),
      totalItemsInTable () {
        return this.totalPromoCodesItems || (this.totalPromoCodesPages * this.pagination.rowsPerPage)
      },
      displayStatus () {
        return this.promocodeSettings.areEnabled ? 'Enabled' : 'Disabled'
      }
    },
    validations: {
      promocodeSettings: {
        explanation: { required },
        areEnabled: { required }
      }
    },
    watch: {
      filterName () {
        this.getPromoCodes()
      },
      pagination: {
        handler (val, oldVal) {
          if (oldVal && !this.isPaginationChanged(val, oldVal)) return
          this.getPromoCodes()
        },
        immediate: true
      },
      filterStatus () {
        this.getPromoCodes()
      },
      filterUseCount () {
        this.getPromoCodes()
      },
      getSettings: {
        handler (newVal) {
          if(!isEmpty(newVal)) {
            this.setPromoCodeSettingData()
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'getPromoCodesList',
        'updatePromoCodeSettings',
        'fetchUsers'
      ]),
      pathOr,
      getPromoCodes: debounce(async function () {
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let itemsOnPage = equals(rowsPerPage, -1) ? this.totalLocationsItems : rowsPerPage
        const sort = descending ? 'Desc' : 'Asc'
        const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const getParams = {
          page: pageCheck,
          itemsOnPage,
          filter: {
            filterName: this.filterName,
            filterStatus: this.filterStatus,
            filterUseCount: this.filterUseCount,
          },
          sort,
          name
        }
        await this.getPromoCodesList(getParams)
        this.loading = false
      }, timeSettings.delayTime),
      showEditModal (item) {
        if (!item.target) {
          this.editableItem = clone(item)
        }
        this.isModalOpen = true
      },
      async savePromoCode () {
        try {
          this.$refs.promoCodesForm.$v.$touch()
          if (this.$refs.promoCodesForm.$v.$invalid) return
          await this.$refs.promoCodesForm.savePromoCodeItem()
          this.editableItem = null
          await this.getPromoCodes()
          this.closeModal()
        } catch (err) {
          throw err
        }
      },
      async removeNomineeItem (id) {
        await this.removeNominee(id)
        await this.getPromoCodes()
      },
      closeModal () {
        this.editableItem = null
        this.isModalOpen = false
      },
      reset () {
        this.pagination.sortBy = null
        this.pagination.descending = false
        this.filterTitle = ''
        this.filterType = ''
        this.filterDescription = ''
        this.filterName = ''
        this.filterStatus = ''
        this.filterUseCount = ''
        this.showFilter = false
      },
      convertDate (dateISO) {
        return this.$moment(dateISO).utc().format('YYYY-MM-DD');
      },
      getInteger (value) {
        return value === '' ? '' : value * 100
      },
      showPromocodesSettings () {
        this.isPromocodeDialogShown = true
      },
      hidePromocodesSettings () {
        this.isPromocodeDialogShown = false
      },
      savePromoCodeSettings () {
        this.updatePromoCodeSettings(this.promocodeSettings)
      },
      setPromoCodeSettingData () {
        this.promocodeSettings = pathOr('', ['promoCodeSetting'], this.getSettings)
      },
      getDate (date) {
        const d = new Date(date)
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getUTCFullYear()
        return `${month} / ${day} / ${year}`
      },
      getAdminByPackage (lastModifiedAdminId) {
        if (this.getUsersList.length === 0) return
        if (lastModifiedAdminId) {
          const adminThatDidEditLast = this.getUsersList.find(user => user.id === lastModifiedAdminId)
          return adminThatDidEditLast ? adminThatDidEditLast.userName : ''
        }
        return ''
      },
      isPaginationChanged (val, oldVal) {
        return val.rowsPerPage !== oldVal.rowsPerPage ||
          val.sortBy !== oldVal.sortBy ||
          val.descending !== oldVal.descending ||
          val.page !== oldVal.page
      }
    },
    created () {
      this.getPromoCodes()
      this.fetchUsers({ page: 0, itemsOnPage: 999999 })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/PromoCodes/index.vue